/* Exact Kooks fitment is bound to the approved product, SKU and source segments. */
(() => {
  const stable = value => Array.isArray(value) ? value.map(stable) : value && typeof value === 'object'
    ? Object.fromEntries(Object.keys(value).sort().map(key => [key, stable(value[key])])) : value;
  const equal = (a, b) => JSON.stringify(stable(a)) === JSON.stringify(stable(b));
  const unique = values => [...new Set(values)].sort();
  const caches = new Map();
  const load = url => {
    if (!caches.has(url)) caches.set(url, fetch(url, {credentials:'same-origin'}).then(response => {
      if (!response.ok) throw new Error('Fitment projection unavailable');
      return response.json();
    }));
    return caches.get(url);
  };
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function init(root, prose, dataNode, data) {
    // The static supplier list covers the grouped range. Present the selected SKU below.
    prose.querySelectorAll('h2,h3').forEach(heading=>{
      const list=heading.nextElementSibling;
      if(heading.textContent.trim().toLowerCase()==='vehicle fitment' && list?.tagName==='UL'){
        heading.hidden=true;list.hidden=true;list.dataset.kooksRangeFitmentSource='true';
      }
    });
    const section=element('section', '', 'product-fitment-details');
    section.setAttribute('data-ha-fitment-details','');
    section.setAttribute('aria-labelledby','product-fitment-details-heading');
    const heading=element('h2', data.labels.heading, 'product-fitment-details__heading');
    heading.id='product-fitment-details-heading';
    section.append(heading);
    const status=element('p', data.labels.loading, 'product-fitment-details__check');
    status.setAttribute('aria-live','polite'); section.append(status);
    const content=element('div'); section.append(content); prose.append(section); dataNode.remove();
    let projection=null;
    function render() {
      content.replaceChildren();
      delete section.dataset.selectedSku;
      delete section.dataset.approvedApplications;
      const input=root.querySelector('[data-ha-variant-id]');
      const selected=String(input ? input.value : data.selectedVariantId || '');
      const native=(data.variants || []).find(variant=>String(variant.id)===selected);
      if (!native) {status.textContent=data.labels.chooseSku; return;}
      const product=projection?.products?.[data.productGid];
      const approved=product?.variants?.['gid://shopify/ProductVariant/'+selected];
      const ids=unique([...(native.fitmentIds || []),...(native.overflowIds || [])]);
      if (!projection || projection.schemaVersion!=='ha-kooks-approved-fitment.v1' || !projection.batchId ||
          product?.handle!==data.productHandle || approved?.sku!==native.sku ||
          !equal(ids,approved.fitmentIds) || !equal(native.segments || [],approved.segments)) {
        status.textContent=data.labels.unavailable; return;
      }
      const applications=[...new Map(approved.applications.map(application=>[JSON.stringify(stable(application)),application])).values()];
      section.dataset.selectedSku=native.sku;
      section.dataset.approvedApplications=String(applications.length);
      if (!applications.length) {
        status.textContent=data.labels.component;
        return;
      }
      status.textContent=data.labels.selectedSku.replace('{sku}',native.sku);
      const groups=new Map();
      applications.forEach(application=>{
        const key=application.make+'\u0000'+application.model;
        if (!groups.has(key)) groups.set(key,{make:application.make,model:application.model,applications:[]});
        groups.get(key).applications.push(application);
      });
      const table=element('div','','product-fitment-table');
      const ordered=[...groups.values()].sort((a,b)=>(a.make+' '+a.model).localeCompare(b.make+' '+b.model,'en',{numeric:true}));
      let searchInput=null;
      if (ordered.length>=4 || applications.length>=12) {
        const search=element('label','','product-fitment-search');
        search.append(element('span',data.labels.search,'visually-hidden'));
        searchInput=element('input'); searchInput.type='search'; searchInput.placeholder=data.labels.search;
        search.append(searchInput); content.append(search);
      }
      ordered.forEach(group=>{
        const details=element('details','','product-fitment-model'); details.open=ordered.length<=2;
        const summary=element('summary','','product-fitment-model__summary');
        summary.append(element('span',group.make+' '+group.model,'product-fitment-model__name'));
        summary.append(element('span',data.labels.applicationDetail,'product-fitment-model__years'));
        summary.append(element('span',String(group.applications.length),'product-fitment-model__count'));
        const toggle=element('span','','product-fitment-model__toggle'); toggle.setAttribute('aria-hidden','true'); summary.append(toggle);
        const list=element('ul','','product-fitment-applications');
        group.applications.forEach(application=>{
          const item=element('li','','product-fitment-application');
          item.dataset.canonicalId=application.canonicalId;
          if (application.engineId) item.dataset.canonicalEngineId=application.engineId;
          item.append(element('span',application.label));
          if (application.conditions.length) item.append(element('small',application.conditions.join('. ')));
          list.append(item);
        });
        details.dataset.searchText=JSON.stringify(group).toLowerCase(); details.append(summary,list); table.append(details);
      });
      content.append(table);
      if (searchInput) searchInput.addEventListener('input',()=>{
        const query=searchInput.value.trim().toLowerCase();
        table.querySelectorAll('details').forEach(details=>{
          details.hidden=Boolean(query && !details.dataset.searchText.includes(query));
          if (query && !details.hidden) details.open=true;
        });
      });
    }
    root.addEventListener('change',()=>queueMicrotask(()=>{
      // An incomplete option choice clears the native id. Never substitute the default SKU.
      const input=root.querySelector('[data-ha-variant-id]');
      if (input && !input.value) {content.replaceChildren();status.textContent=data.labels.chooseSku;delete section.dataset.selectedSku;delete section.dataset.approvedApplications;return;}
      render();
    }));
    window.addEventListener('popstate',()=>queueMicrotask(render));
    load(data.kooksProjectionUrl).then(result=>{projection=result;render();}).catch(()=>{status.textContent=data.labels.unavailable;});
  }
  window.hooniesKooksProductFitment={init};
})();
